import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => createStyles({
  wrapper: {
    alignItems: 'center',
    background: '#FAFAFA',
    display: 'flex',
    height: theme.spacing(8),
    padding: theme.spacing(2.5),
  },
  nav: {
    overflow: 'hidden',
    width: '100%',
  },
  list: {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: theme.spacing(1.25),
    listStyle: 'none',
    margin: 0,
    padding: 0,
    whiteSpace: 'nowrap',
  },
  item: {
    color: theme.palette.secondary.main,
    fontFamily: theme.typography.fontFamily,
    fontSize: '0.875rem',
    fontWeight: 600,
    '&:last-of-type': {
      minWidth: 0,
    },
  },
  separator: {
    alignItems: 'center',
    color: '#999999',
    display: 'flex',
    '&:first-of-type': {
      display: 'none',
    },
  },
  itemLink: {
    color: '#999999',
    display: 'block',
    height: '100%',
    textDecoration: 'none',
  },
  itemContent: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    gap: theme.spacing(1.25),
  },
  itemLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));
